import React from "react";
import { Route, Routes } from "react-router-dom";
import ContractInvoices from "../pages/jobs/ContractInvoices";

export default function ContractInvsRoutes() {
  return (
    <Routes>
      <Route path="" element={<ContractInvoices />} />
    </Routes>
  );
}
